/*
 * @Author:  
 * @Date: 2019-02-27 11:17:53 
 * @Last Modified by: 
 * @Last Modified time: 2019-10-15 15:22:29
 * 用户数据
 */

export default {
  state: {
    currentMenu: {}
  },
  mutations: {
    setCurrentMenu(state, value) {
      state.currentMenu = value;
    }
  }
}